import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  getAllMessagesByChatId,
  selectCurrentSelectedChat,
  MessageType,
} from 'models/twilio';
import isSupportedImage from '../utils/isSupportedImage';

const useConverastionImages = () => {
  const currentSelectedChat = useSelector(selectCurrentSelectedChat);
  const messages = useSelector(getAllMessagesByChatId(currentSelectedChat));

  const imageMessages = useMemo(() => messages
    .filter((message) => message.attributes.messageType === MessageType.File)
    .filter((message) => {
      const file = message.attributes?.file;
      return isSupportedImage(file);
    }), [messages]);

  return imageMessages;
};

export default useConverastionImages;
